import { PARAMETER_TRANSLATION_KEYS } from './node-parameters.keys';

const MODEL_PARAMETERS_EN = {
  // SHARED
  [PARAMETER_TRANSLATION_KEYS.SHARED.ASPECT_RATIO.TITLE]: 'Aspect Ratio',
  [PARAMETER_TRANSLATION_KEYS.SHARED.SEED.TITLE]: 'Seed',
  [PARAMETER_TRANSLATION_KEYS.SHARED.SEED.DESCRIPTION]:
    'The same seed and the same prompt given to the same version of the model will output the same image every time.',

  // MUXV2
  [PARAMETER_TRANSLATION_KEYS.MUXV2.OPTIONS.TITLE]: 'Options',
  [PARAMETER_TRANSLATION_KEYS.MUXV2.OPTIONS.DESCRIPTION]: 'Array of elements to populate the list',

  // MASKS
  [PARAMETER_TRANSLATION_KEYS.MASKS.FEATHER.TITLE]: 'Feather Mask',
  [PARAMETER_TRANSLATION_KEYS.MASKS.FEATHER.DESCRIPTION]: 'Applies blur to the selected masks',

  [PARAMETER_TRANSLATION_KEYS.MASKS.MATTE_CHOKER.TITLE]: 'Shrink / Expand mask',
  [PARAMETER_TRANSLATION_KEYS.MASKS.MATTE_CHOKER.DESCRIPTION]: 'Add or reduce pixels to the masks edges',

  [PARAMETER_TRANSLATION_KEYS.MASKS.INVERT.TITLE]: 'Invert Mask',
  [PARAMETER_TRANSLATION_KEYS.MASKS.INVERT.DESCRIPTION]: 'Renders the inverse of the mask selection',

  // MINIMAX_IMAGE01
  [PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.NUMBER_OF_IMAGES.TITLE]: 'Number Of Images',
  [PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.NUMBER_OF_IMAGES.DESCRIPTION]: 'Number of images to generate',
  [PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.ASPECT_RATIO.DESCRIPTION]: 'Image aspect ratio',
  [PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.PROMPT_OPTIMIZER.TITLE]: 'Prompt Optimizer',
  [PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_IMAGE01.PROMPT_OPTIMIZER.DESCRIPTION]: 'Use prompt optimizer',

  // REVE
  [PARAMETER_TRANSLATION_KEYS.MODELS.REVE.ASPECT_RATIO.DESCRIPTION]: 'Image aspect ratio',

  // IMAGEN3
  [PARAMETER_TRANSLATION_KEYS.MODELS.IMAGEN3.ASPECT_RATIO.DESCRIPTION]: 'Aspect ratio of the generated image',
  [PARAMETER_TRANSLATION_KEYS.MODELS.IMAGEN3.SAFETY_FILTER_LEVEL.TITLE]: 'Safety Filter Level',
  [PARAMETER_TRANSLATION_KEYS.MODELS.IMAGEN3.SAFETY_FILTER_LEVEL.DESCRIPTION]:
    'block_low_and_above is strictest, block_medium_and_above blocks some prompts, block_only_high is most permissive but some prompts will still be blocked',

  // WAN_VIDEO
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.ASPECT_RATIO.DESCRIPTION]: 'Video aspect ratio',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.FRAME_NUM.TITLE]: 'Frame Num',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.FRAME_NUM.DESCRIPTION]:
    'Video duration in frames (based on standard 16fps playback)',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.RESOLUTION.TITLE]: 'Resolution',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.RESOLUTION.DESCRIPTION]: 'Video resolution',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_STEPS.TITLE]: 'Sample Steps',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_STEPS.DESCRIPTION]:
    'Number of sampling steps (higher = better quality but slower)',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_GUIDE_SCALE.TITLE]: 'Sample Guide Scale',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_GUIDE_SCALE.DESCRIPTION]:
    'Classifier free guidance scale (higher values strengthen prompt adherence)',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_SHIFT.TITLE]: 'Sample Shift',
  [PARAMETER_TRANSLATION_KEYS.MODELS.WAN_VIDEO.SAMPLE_SHIFT.DESCRIPTION]:
    'Sampling shift factor for flow matching (recommended range: 8-12)',

  // BR_BGREPLACE
  [PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.FAST.TITLE]: 'Fast Generation',
  [PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.FAST.DESCRIPTION]:
    'When true, the generation will utilize the fast mode which provides the best balance between speed and quality',
  [PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.REFINE_PROMPT.TITLE]: 'Refine Prompt',
  [PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.REFINE_PROMPT.DESCRIPTION]:
    'When true, an additional logic takes the bg_prompt that was included and adjusts it to achieve optimal results. Built with Meta Llama 3.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.ORIGINAL_QUALITY.TITLE]: 'Original Quality',
  [PARAMETER_TRANSLATION_KEYS.MODELS.BR_BGREPLACE.ORIGINAL_QUALITY.DESCRIPTION]:
    "When true, the output image retains the original input image's size; otherwise, the image is scaled to 1 megapixel (1MP) while preserving its aspect ratio.",

  // LUMA_PHOTON
  [PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.ASPECT_RATIO.DESCRIPTION]: 'Image aspect ratio',
  [PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.IMAGE_REFERENCE_WEIGHT.TITLE]: 'Image Reference Weight',
  [PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.IMAGE_REFERENCE_WEIGHT.DESCRIPTION]:
    'Weight of the reference image. Larger values will make the reference image have a stronger influence on the generated image.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.STYLE_REFERENCE_WEIGHT.TITLE]: 'Style Reference Weight',
  [PARAMETER_TRANSLATION_KEYS.MODELS.LUMA_PHOTON.STYLE_REFERENCE_WEIGHT.DESCRIPTION]:
    'Weight of the style reference image',

  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.ASPECT_RATIO.DESCRIPTION]: 'Aspect ratio for the generated image',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.GUIDANCE.TITLE]: 'Guidance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.GUIDANCE.DESCRIPTION]:
    'Guidance for generated image. Ignored for flux-schnell',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_FORMAT.DESCRIPTION]: 'Format of the output images',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_QUALITY.TITLE]: 'Output Quality',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_FAST.OUTPUT_QUALITY.DESCRIPTION]:
    'Quality when saving the output images, from 0 to 100. 100 is best quality, 0 is lowest quality. Not relevant for .png outputs',

  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.SEED.DESCRIPTION]:
    'Seed value for random number generator. Uncheck for reproducible results.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.STEPS.TITLE]: 'Steps',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.STEPS.DESCRIPTION]:
    'Number of diffusion steps. Higher values yield finer details but increase processing time.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.GUIDANCE.TITLE]: 'Guidance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.GUIDANCE.DESCRIPTION]:
    'Controls the balance between adherence to the text as well as image prompt and image quality/diversity. Higher values make the output more closely match the prompt, but may reduce diversity.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.OUTPUT_FORMAT.DESCRIPTION]: 'Format of the output images.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.SAFETY_TOLERANCE.TITLE]: 'Safety Tolerance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.SAFETY_TOLERANCE.DESCRIPTION]:
    'Safety tolerance, 1 is most strict and 6 is most permissive',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.PROMPT_UPSAMPLING.TITLE]: 'Prompt Upsampling',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_DEPTH_PRO.PROMPT_UPSAMPLING.DESCRIPTION]:
    'Automatically modify the prompt for more creative generation',

  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.SEED.DESCRIPTION]:
    'Seed value for random number generator. Uncheck for reproducible results.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.STEPS.TITLE]: 'Steps',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.STEPS.DESCRIPTION]:
    'Number of diffusion steps. Higher values yield finer details but increase processing time.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.GUIDANCE.TITLE]: 'Guidance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.GUIDANCE.DESCRIPTION]:
    'Controls the balance between adherence to the text as well as image prompt and image quality/diversity. Higher values make the output more closely match the prompt, but may reduce diversity.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.OUTPUT_FORMAT.DESCRIPTION]: 'Format of the output images.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.SAFETY_TOLERANCE.TITLE]: 'Safety Tolerance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.SAFETY_TOLERANCE.DESCRIPTION]:
    'Safety tolerance, 1 is most strict and 6 is most permissive',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.PROMPT_UPSAMPLING.TITLE]: 'Prompt Upsampling',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_CANNY_PRO.PROMPT_UPSAMPLING.DESCRIPTION]:
    'Automatically modify the prompt for more creative generation',

  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.SEED.DESCRIPTION]:
    'Seed value for random number generator. Uncheck for reproducible results.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.GUIDANCE.TITLE]: 'Guidance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.GUIDANCE.DESCRIPTION]: 'Guidance for generated image',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.MEGAPIXELS.TITLE]: 'Megapixels',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.MEGAPIXELS.DESCRIPTION]:
    'Approximate number of megapixels for generated image',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_OUTPUTS.TITLE]: 'Num Outputs',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_OUTPUTS.DESCRIPTION]: 'Number of outputs to generate',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.ASPECT_RATIO.DESCRIPTION]: 'Aspect ratio for the generated image',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_FORMAT.DESCRIPTION]: 'Format of the output images',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_QUALITY.TITLE]: 'Output Quality',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.OUTPUT_QUALITY.DESCRIPTION]:
    'Quality when saving the output images, from 0 to 100. 100 is best quality, 0 is lowest quality. Not relevant for .png outputs',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_INFERENCE_STEPS.TITLE]: 'Num Inference Steps',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.NUM_INFERENCE_STEPS.DESCRIPTION]:
    'Number of denoising steps. Recommended range is 28-50',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.DISABLE_SAFETY_CHECKER.TITLE]: 'Disable Safety Checker',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_REDUX_DEV.DISABLE_SAFETY_CHECKER.DESCRIPTION]:
    'Disable safety checker for generated images.',

  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.MODEL.TITLE]: 'Model',
  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.MODEL.DESCRIPTION]: 'The GPT Image model version',
  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.SIZE.TITLE]: 'Size',
  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.SIZE.DESCRIPTION]: 'The size of the generated images',
  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.QUALITY.TITLE]: 'Quality',
  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.QUALITY.DESCRIPTION]:
    'The quality of the image that will be generated. High creates images with finer details and greater consistency',
  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.BACKGROUND.TITLE]: 'Background',
  [PARAMETER_TRANSLATION_KEYS.MODELS.GPT_IMAGE_1.BACKGROUND.DESCRIPTION]:
    'Whether to generate images with transparent or opaque backgrounds',

  // ANY_LLM
  [PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.TITLE]: 'Model',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.MODEL.DESCRIPTION]: 'Name of the model to use',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.TEMPERATURE.TITLE]: 'Temperature',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.TEMPERATURE.DESCRIPTION]:
    'This setting influences the variety in the model responses. Lower values lead to more predictable and typical responses, while higher values encourage more diverse and less common responses. At 0, the model always gives the same response for a given input.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.THINKING.TITLE]: 'Thinking',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ANY_LLM.THINKING.DESCRIPTION]:
    'Enhanced reasoning capabilities for complex task (For supported models only)',

  // IMAGE_DESCRIBER
  [PARAMETER_TRANSLATION_KEYS.MODELS.IMAGE_DESCRIBER.PROMPT.TITLE]: 'System Instructions',
  [PARAMETER_TRANSLATION_KEYS.MODELS.IMAGE_DESCRIBER.PROMPT.DESCRIPTION]:
    'Instructions for how the model should analyze and describe images',

  // PROMPT_ENHANCER
  [PARAMETER_TRANSLATION_KEYS.MODELS.PROMPT_ENHANCER.SYSTEM_PROMPT.TITLE]: "Model's Instructions",
  [PARAMETER_TRANSLATION_KEYS.MODELS.PROMPT_ENHANCER.SYSTEM_PROMPT.DESCRIPTION]:
    'Describe the purpose of the model (e.g "you are a prompt generator")',

  // SD SKETCH
  [PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_STRENGTH.TITLE]: 'Image strength',
  [PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_STRENGTH.DESCRIPTION]:
    'How much influence the image has on the generation',
  [PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_TYPE.TITLE]: 'Type',
  [PARAMETER_TRANSLATION_KEYS.MODELS.SD_SKETCH.CONTROL_TYPE.DESCRIPTION]: 'Type of the controlNet',

  // MINIMAX_VIDEO_DIRECTOR
  [PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_VIDEO_DIRECTOR.PROMPT_OPTIMIZER.TITLE]: 'Prompt Optimizer',
  [PARAMETER_TRANSLATION_KEYS.MODELS.MINIMAX_VIDEO_DIRECTOR.PROMPT_OPTIMIZER.DESCRIPTION]: 'Use prompt optimizer',

  // MESHY
  [PARAMETER_TRANSLATION_KEYS.MODELS.MESHY.SURFACE_MODE.TITLE]: 'Surface Mode',
  [PARAMETER_TRANSLATION_KEYS.MODELS.MESHY.SURFACE_MODE.DESCRIPTION]: '',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.STEPS.TITLE]: 'Steps',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.STEPS.DESCRIPTION]: 'Number of inference steps',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.GUIDANCE_SCALE.TITLE]: 'Guidance Scale',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.GUIDANCE_SCALE.DESCRIPTION]: 'Guidance scale',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.RANDOMIZE_SEED.TITLE]: 'Randomize Seed',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.RANDOMIZE_SEED.DESCRIPTION]: 'Randomize the seed for each generation',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.OCTREE_RESOLUTION.TITLE]: 'Octree Resolution',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.OCTREE_RESOLUTION.DESCRIPTION]: 'Octree resolution',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.REMOVE_BACKGROUND.TITLE]: 'Remove Background',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.REMOVE_BACKGROUND.DESCRIPTION]: 'Remove image background',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.NUM_CHUNKS.TITLE]: 'Num Chunks',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.NUM_CHUNKS.DESCRIPTION]: 'Number of chunks',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.TARGET_FACE_NUM.TITLE]: 'Target Face Num',
  [PARAMETER_TRANSLATION_KEYS.MODELS.HUNYUAN3D.TARGET_FACE_NUM.DESCRIPTION]:
    'Target number of faces for mesh simplification',

  // FLUX_11_PRO
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.ASPECT_RATIO.DESCRIPTION]: 'Aspect ratio for the generated image',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.WIDTH.TITLE]: 'Width',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.WIDTH.DESCRIPTION]:
    "Width of the generated image in text-to-image mode. Only used when aspect_ratio=custom. Must be a multiple of 32 (if it's not, it will be rounded to nearest multiple)",
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.HEIGHT.TITLE]: 'Height',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.HEIGHT.DESCRIPTION]:
    "Height of the generated image in text-to-image mode. Only used when aspect_ratio=custom. Must be a multiple of 32 (if it's not, it will be rounded to nearest multiple)",
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.SAFETY_TOLERANCE.TITLE]: 'Safety Tolerance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.SAFETY_TOLERANCE.DESCRIPTION]:
    'Safety tolerance, 1 is most strict and 6 is most permissive',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.PROMPT_UPSAMPLING.TITLE]: 'Prompt Upsampling',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.PROMPT_UPSAMPLING.DESCRIPTION]:
    'Automatically modify the prompt for more creative generation',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_FORMAT.DESCRIPTION]: 'Format of the output images.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_QUALITY.TITLE]: 'Output Quality',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO.OUTPUT_QUALITY.DESCRIPTION]:
    'Quality when saving the output images, from 0 to 100. 100 is best quality, 0 is lowest quality. Not relevant for .png outputs',

  // FLUX_11_PRO_ULTRA
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.IMAGE_PROMPT_STRENGTH.TITLE]: 'Image Prompt Strength',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.IMAGE_PROMPT_STRENGTH.DESCRIPTION]:
    'Blend between the prompt and the image prompt.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.ASPECT_RATIO.DESCRIPTION]:
    'Aspect ratio for the generated image',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.SAFETY_TOLERANCE.TITLE]: 'Safety Tolerance',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.SAFETY_TOLERANCE.DESCRIPTION]:
    'Safety tolerance, 1 is most strict and 6 is most permissive',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.RAW.TITLE]: 'Raw',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.RAW.DESCRIPTION]:
    'Generate less processed, more natural-looking images',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_11_PRO_ULTRA.OUTPUT_FORMAT.DESCRIPTION]: 'Format of the output images.',
  // FLUX_KONTEXT
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.MODEL.TITLE]: 'Kontext Model',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.MODEL.DESCRIPTION]:
    "Max yields the highest quality while it's more expensive. Dev has the lowest quality but costs less",
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.ASPECT_RATIO.DESCRIPTION]:
    'Determines how the output resolution is set for image editing.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.NUM_INFERENCE_STEPS.TITLE]: 'Num Inference Steps',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.NUM_INFERENCE_STEPS.DESCRIPTION]:
    'The number of inference steps to perform.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.GUIDANCE_SCALE.TITLE]: 'Guidance scale (CFG)',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.GUIDANCE_SCALE.DESCRIPTION]:
    'The CFG (Classifier Free Guidance) scale is a measure of how close you want the model to stick to your prompt when looking for a related image to show...',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT.OUTPUT_FORMAT.DESCRIPTION]: 'Output format',

  // FLUX_KONTEXT_MULTI_IMAGE
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT_MULTI_IMAGE.ASPECT_RATIO.DESCRIPTION]:
    "Aspect ratio of the generated image. Use 'match_input_image' to match the aspect ratio of the input image.",
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT_MULTI_IMAGE.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.FLUX_KONTEXT_MULTI_IMAGE.OUTPUT_FORMAT.DESCRIPTION]:
    'Output format for the generated image',

  // TOPAZ_IMAGE_SHARPEN
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.MODEL.TITLE]: 'Model',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.MODEL.DESCRIPTION]:
    'The model to use for processing the image.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.OUTPUT_FORMAT.TITLE]: 'Output Format',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.OUTPUT_FORMAT.DESCRIPTION]:
    'The desired format of the output image.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.SUBJECT_DETECTION.TITLE]: 'Subject Detection',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.SUBJECT_DETECTION.DESCRIPTION]:
    'Specifies whether you want to detect all subjects in the image, only the foreground subject, or only the background for the AI model to run on.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT.TITLE]: 'Face Enhancement',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT.DESCRIPTION]:
    "By default, faces (if any) are enhanced during image processing as well. Set `face_enhancement` to `false` if you don't want this.",
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_CREATIVITY.TITLE]:
    'Face Enhancement Creativity',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_CREATIVITY.DESCRIPTION]:
    'Choose the level of creativity for face enhancement from 0 to 1. Defaults to `0`, and is ignored if `face_enhancement` is `false`.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_STRENGTH.TITLE]: 'Face Enhancement Strength',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_SHARPEN.FACE_ENHANCEMENT_STRENGTH.DESCRIPTION]:
    'Control how sharp the enhanced faces are relative to the background from 0 to 1. Defaults to `0.8`, and is ignored if `face_enhancement` is `false`.',

  // TOPAZ_IMAGE_UPSCALE
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.MODEL.TITLE]: 'Model',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.MODEL.DESCRIPTION]: 'Model to use for image enhancement.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.UPSCALE_FACTOR.TITLE]: 'Upscale Factor',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.UPSCALE_FACTOR.DESCRIPTION]:
    'Factor to upscale the video by (e.g. 2.0 doubles width and height)',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.CROP_TO_FILL.TITLE]: 'Crop To Fill',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.CROP_TO_FILL.DESCRIPTION]: '',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT.TITLE]: 'Face Enhancement',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT.DESCRIPTION]:
    'Whether to apply face enhancement to the image.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.SUBJECT_DETECTION.TITLE]: 'Subject Detection',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.SUBJECT_DETECTION.DESCRIPTION]:
    'Subject detection mode for the image enhancement.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_STRENGTH.TITLE]: 'Face Enhancement Strength',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_STRENGTH.DESCRIPTION]:
    'Strength of the face enhancement. 0.0 means no enhancement, 1.0 means maximum enhancement. Ignored if face ehnancement is disabled.',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_CREATIVITY.TITLE]:
    'Face Enhancement Creativity',
  [PARAMETER_TRANSLATION_KEYS.MODELS.TOPAZ_IMAGE_UPSCALE.FACE_ENHANCEMENT_CREATIVITY.DESCRIPTION]:
    'Creativity level for face enhancement. 0.0 means no creativity, 1.0 means maximum creativity. Ignored if face ehnancement is disabled.',

  // KLING
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.MODEL.TITLE]: 'Model',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.MODEL.DESCRIPTION]: 'Kling model version',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.DURATION.TITLE]: 'Duration',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.DURATION.DESCRIPTION]: 'Duration of the generated video in seconds',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.CFG_SCALE.TITLE]: 'CFG Scale',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.CFG_SCALE.DESCRIPTION]: 'Classifier-free guidance scale',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.SHOT_TYPE.TITLE]: 'Shot Type',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.SHOT_TYPE.DESCRIPTION]: 'Type of camera shot',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.ASPECT_RATIO.DESCRIPTION]: 'Aspect ratio of the generated video',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.GENERATE_AUDIO.TITLE]: 'Generate Audio',
  [PARAMETER_TRANSLATION_KEYS.MODELS.KLING.GENERATE_AUDIO.DESCRIPTION]: 'Whether to generate audio for the video',

  // ELEVEN_LABS_VOICE_CHANGER
  [PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.VOICE.TITLE]: 'Voice',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.VOICE.DESCRIPTION]: 'The voice to change to',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.REMOVE_BACKGROUND_NOISE.TITLE]:
    'Remove Background Noise',
  [PARAMETER_TRANSLATION_KEYS.MODELS.ELEVEN_LABS_VOICE_CHANGER.REMOVE_BACKGROUND_NOISE.DESCRIPTION]:
    'If set, will remove the background noise from your audio input using ElevenLabs audio isolation model',
};

export default MODEL_PARAMETERS_EN;
